module.exports = __webpack_public_path__ + "static/img/illus-01.070cb04.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illus-01.webp
// module id = 102
// module chunks = 0